import AddCardToWallet from './AddCardToWallet';

export default AddCardToWallet;
